module.exports = __webpack_public_path__ + "img/ageV.57528f02.jpg";